/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a driver to avoid`)
};

const es_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un piloto a evitar`)
};

const de_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrer zum Vermeiden wählen`)
};

const nl_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een coureur om te vermijden`)
};

const fr_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un pilote à éviter`)
};

const it_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un pilota da evitare`)
};

const pt_br2_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um piloto para evitar`)
};

const pt_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe um piloto a evitar`)
};

const ja_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回避するドライバーを選択`)
};

const zh_f1_apex_avoid_pick_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要回避的车手`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_avoid_pick_driver = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_avoid_pick_driver(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_avoid_pick_driver", locale)
	if (locale === "en") return en_f1_apex_avoid_pick_driver(inputs)
	if (locale === "es") return es_f1_apex_avoid_pick_driver(inputs)
	if (locale === "de") return de_f1_apex_avoid_pick_driver(inputs)
	if (locale === "nl") return nl_f1_apex_avoid_pick_driver(inputs)
	if (locale === "fr") return fr_f1_apex_avoid_pick_driver(inputs)
	if (locale === "it") return it_f1_apex_avoid_pick_driver(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_avoid_pick_driver(inputs)
	if (locale === "pt") return pt_f1_apex_avoid_pick_driver(inputs)
	if (locale === "ja") return ja_f1_apex_avoid_pick_driver(inputs)
	return zh_f1_apex_avoid_pick_driver(inputs)
};